import { render, staticRenderFns } from "./MemberSearch.vue?vue&type=template&id=81d2b2d2&scoped=true&lang=pug&"
import script from "./MemberSearch.vue?vue&type=script&lang=js&"
export * from "./MemberSearch.vue?vue&type=script&lang=js&"
import style0 from "./MemberSearch.vue?vue&type=style&index=0&id=81d2b2d2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2b2d2",
  null
  
)

/* custom blocks */
import block0 from "./MemberSearch.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports